<template>
  <div class="discount-management">
    <div class="relative">
      <fragment v-if="[8, 7, 6, 4, 1, 2].includes(activity)">
        <el-tabs
          class="modify-el__tabs"
          v-model="activeName"
          @tab-click="handleClick"
        >
          <el-tab-pane label="有效" name="1" lazy>
            <SearchComponent
              ref="search"
              :condition="condition"
              :activeName="activeName"
              :routeName="$route.name"
              :activity="activity"
              @updateData="_updateData"
            />
            <TableComponent
              ref="table"
              :tableData="tableData"
              :pagination="pagination"
              :activeName="activeName"
              :routeName="$route.name"
              :activity="activity"
              @updateData="_updateData"
            />
            <el-button
              size="220"
              round
              v-permission:add="$route.meta.permission"
              class="iconfont icon-xinzeng"
              @click="jumpRoute"
            >
              {{ btnText }}
            </el-button>
          </el-tab-pane>
          <el-tab-pane label="已失效" name="2" lazy>
            <SearchComponent
              ref="search"
              :condition="condition"
              :activeName="activeName"
              :routeName="$route.name"
              :activity="activity"
              @updateData="_updateData"
            />
            <TableComponent
              ref="table"
              :tableData="tableData"
              :pagination="pagination"
              :activeName="activeName"
              :routeName="$route.name"
              :activity="activity"
              @updateData="_updateData"
            />
            <el-button
              size="220"
              round
              class="iconfont icon-xinzeng"
              v-permission:add="$route.meta.permission"
              @click="jumpRoute"
            >
              {{ btnText }}
            </el-button>
          </el-tab-pane>
          <el-tab-pane label="全部" name="0" lazy>
            <SearchComponent
              ref="search"
              :condition="condition"
              :activeName="activeName"
              :routeName="$route.name"
              :activity="activity"
              @updateData="_updateData"
            />
            <TableComponent
              ref="table"
              :tableData="tableData"
              :pagination="pagination"
              :activeName="activeName"
              :routeName="$route.name"
              :activity="activity"
              @updateData="_updateData"
            />
            <el-button
              size="220"
              round
              class="iconfont icon-xinzeng"
              v-permission:add="$route.meta.permission"
              @click="jumpRoute"
            >
              {{ btnText }}
            </el-button>
          </el-tab-pane>
        </el-tabs>
      </fragment>
      <fragment v-if="[3, 5].includes(activity)">
        <SearchComponent
          ref="search"
          :condition="condition"
          :activeName="activeName"
          :routeName="$route.name"
          :activity="activity"
          @updateData="_updateData"
        />
        <TableComponent
          ref="table"
          :tableData="tableData"
          :pagination="pagination"
          :activeName="activeName"
          :routeName="$route.name"
          :activity="activity"
          @updateData="_updateData"
        />
        <el-button
          size="220"
          round
          class="iconfont icon-xinzeng"
          v-permission:add="$route.meta.permission"
          @click="jumpRoute"
        >
          {{ btnText }}
        </el-button>
      </fragment>
    </div>
  </div>
</template>
<script>
import SearchComponent from '../SearchComponent/'
import TableComponent from '../TableComponent/'
import tabsIndex from 'mixins/tabsIndex'
import updateData from 'mixins/updateData'
// activity 取值 1 折扣 2 秒杀 3 组合 4 积分 5 团购 6 代金券 7 优惠券 8 新品尝鲜
export default {
  name: 'DiscountManagement',
  mixins: [updateData, tabsIndex],
  components: {
    SearchComponent,
    TableComponent
  },
  props: {
    btnText: {
      type: String
    },
    activity: {
      type: Number
    },
    childRoute: {
      type: String
    }
  },
  data() {
    this.keyMap = {
      activity_list: {
        name: 'tableData',
        activity_state: 'activityState',
        activity_title: 'name',
        coupon_id: 'id',
        coupon_number: 'num',
        coupon_use_number: 'usageNum',
        denomination_value: 'amount',
        effective_state: 'state',
        end_time: 'endTime',
        start_time: 'startTime',
        remarks_information: 'info',
        level_name: 'objects',
        voucher_id: 'id',
        voucher_number: 'num',
        voucher_use_number: 'usageNum',
        duty_goods_number: 'duty',
        cross_goods_number: 'cross',
        start_discount: 'startDiscount',
        end_discount: 'endDiscount',
        activity_id: 'id',
        assembly_id: 'id',
        goods_storage: 'stock',
        goods_sku: 'sku',
        assembly_price: 'price',
        goods_type: 'goodsType',
        goods_url: 'url',
        goods_name: 'cnName',
        goods_en: 'enName',
        add_time: 'addTime',
        discount: 'discounts',
        buying_number: 'groupNum'
      }
    }
    return {
      activeName: '1',
      condition: {},
      tableData: [],
      pagination: {
        currentPage: 1,
        recordTotal: -1,
        pageTotal: -1
      }
    }
  },

  created() {
    this._getActiveityList({
      curpage: 1,
      activity_type: this.activity,
      effective_state: this.activeName
    })
  },

  methods: {
    /**
     * 券列表
     * @private
     */
    _getActiveityList(params) {
      this.api.getActivityList(params).then(res => {
        this.utils.setCommonCode(res, this)
      })
    },
    /**
     * 状态栏切换
     */
    handleClick() {
      this._tabsRecord()
      this._getActiveityList({
        curpage: this.pagination.currentPage,
        activity_type: this.activity,
        effective_state: this.activeName
      })
    },
    /**
     * 跳转路由
     */
    jumpRoute() {
      this.$router.push({
        name: this.childRoute,
        query: {
          title: this.btnText,
          type: this.activity
        }
      })
    }
  }
}
</script>
